import React from 'react';
import './List.css'
import { globalVars } from '../../App';
import { listTypes } from './List';

const ListItem = ({name, index, newItem, interactable, onClick, type=listTypes.normal, score }) => {

    //console.log(name);
    //console.log(newItem);
    let className = "list-item";

    if(type == listTypes.ranking && index < 3) {
        className += " final-pos-" + (index+1);
    } else {
        className += " list-item-blue";
    }

    className += " list-item-" + globalVars.type;



    if(newItem) {
        //nuovo elemento
        className += " list-item-new";
        //console.log("nnew");
    }

    if(interactable) {
        className += " list-item-interactable";
    }

    const handleOnClick = () => {
        //console.log("click item");
        if(onClick) {
            onClick(index);
        }
    }


    return (
        type == listTypes.ranking ? (
            <div className={className} onClick={handleOnClick}>
                <span className='place-txt' style={{marginLeft: "30px"}}>{(index + 1) + "."}</span>
                <div style={{width: "20px"}}></div>
                <span className='common-btn-txt'>{name}</span>
                <div style={{flexGrow: 1}}></div>
                <span className='common-btn-txt' style={{marginRight: "50px"}}>{score}</span>
            </div>
        ) : (
            <div className={className} onClick={handleOnClick}>
                <span className='list-item-txt'>{name}</span>
            </div>
        )
    );

}

export default ListItem;
